module.exports = __webpack_public_path__ + "static/img/creator_country_invite_bg.16273e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/creator/creator_country_invite_bg.png
// module id = xlGj
// module chunks = 0